import React, { useCallback, useRef } from "react";
import { Button } from "@/components/ui/button";
import IconProvider from "@/components/ui/IconProvider";

export interface AddButtonProps {
  onClick: () => void;
}

/**
 * Add button component.
 * Renders a plus icon button for adding new items.
 * Includes protection against double-clicks.
 */
export function AddButton({ onClick }: AddButtonProps) {
  const isProcessingRef = useRef(false);

  const handleClick = useCallback(() => {
    // Prevent double-clicks
    if (isProcessingRef.current) return;
    
    isProcessingRef.current = true;
    onClick();
    
    // Reset after a short delay to allow new clicks
    setTimeout(() => {
      isProcessingRef.current = false;
    }, 500);
  }, [onClick]);

  return (
    <Button
      variant="ghost"
      size="sm"
      className="p-2 text-muted-foreground hover:text-foreground hover:bg-muted"
      onClick={handleClick}
      title="Add"
    >
      <IconProvider iconstring="fa-plus" size={16} color="currentColor" />
    </Button>
  );
}

export default AddButton;

